import { useState, useMemo } from 'react'
import { Video, Monitor, Smartphone, Square } from 'lucide-react'
import {
  Dropdown,
  PromptInput,
  GenerateButton,
  MobileBottomBar,
  type DropdownOption,
} from '@/components/ui'
import { ASPECT_RATIOS, type AspectRatio } from '@/config/constants'
import { redirectToVideo } from '@/utils/redirect'

export function TextToVideoForm() {
  const [prompt, setPrompt] = useState('')
  const [aspectRatio, setAspectRatio] = useState<AspectRatio>('horizontal')

  const handleGenerate = () => {
    if (!prompt.trim()) return
    
    // Redirect to pixelmaker.ai with params
    redirectToVideo('t2v', {
      prompt: prompt.trim(),
      aspect_ratio: aspectRatio,
    })
  }

  const aspectRatioOptions: DropdownOption[] = useMemo(
    () =>
      ASPECT_RATIOS.map((ar) => ({
        value: ar.value,
        label: ar.label,
        icon: ar.icon === Monitor ? <Monitor className="size-4" /> :
              ar.icon === Smartphone ? <Smartphone className="size-4" /> :
              <Square className="size-4" />,
      })),
    []
  )

  const isValid = prompt.trim()

  const generateButton = (
    <GenerateButton
      disabled={!isValid}
      className="w-full h-full"
      onClick={handleGenerate}
    >
      <Video className="size-5" />
      Generate Video
    </GenerateButton>
  )

  return (
    <>
      <div className="space-y-4 pb-24 md:pb-0">
        <PromptInput
          value={prompt}
          onChange={setPrompt}
          placeholder="Describe your video... A serene mountain landscape at sunset, with clouds slowly drifting across the sky..."
        />

        {/* Controls Row */}
        <div className="flex flex-col md:flex-row gap-3">
          {/* Aspect Ratio Dropdown */}
          <div className="relative rounded-xl p-[1px] bg-gradient-to-br from-white/[0.12] via-white/[0.04] to-white/[0.08] w-full md:w-[200px] shrink-0">
            <Dropdown
              label="Aspect Ratio"
              value={aspectRatio}
              onChange={(val) => setAspectRatio(val as AspectRatio)}
              options={aspectRatioOptions}
            />
          </div>
          {/* Generate Button - Desktop only */}
          <div className="hidden md:block flex-1 self-stretch">
            {generateButton}
          </div>
        </div>
      </div>

      {/* Fixed bottom bar - Mobile only */}
      <MobileBottomBar>{generateButton}</MobileBottomBar>
    </>
  )
}
